import { render, staticRenderFns } from "./CompanyContactEditor.vue?vue&type=template&id=309cf734"
import script from "./CompanyContactEditor.vue?vue&type=script&lang=ts"
export * from "./CompanyContactEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports